export default "__VITE_ASSET__DyLyKu7S__"